import { render, staticRenderFns } from "./InvoiceCreate.vue?vue&type=template&id=f8007c56&"
import script from "./InvoiceCreate.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports